import { useContext } from '@nuxtjs/composition-api';

export const PaymentMethods = [
  { code: 'credit-card', label: 'Credit Card' },
  { code: 'paypal', label: 'PayPal' },
] as const;
export type ValidPaymentCode = (typeof PaymentMethods)[number]['code'];
export type ValidPaymentMethod = (typeof PaymentMethods)[number];

export const usePaymentMethods = (): Readonly<ValidPaymentMethod[]> => {
  const { $isFlagOn } = useContext();
  return $isFlagOn('paypal')
    ? PaymentMethods
    : PaymentMethods.filter(method => method.code !== 'paypal');
};

export default usePaymentMethods;
